import React, { Fragment } from 'react';
import image_error_account from '../../../assets/images/image_error_account.png';
import ErrorUi from '../../../components/user-interfaces/error/error.ui';

/**
 * Composant de la page d'erreur 404
 * @constructor
 */
export default function ErrorAccountPage() {
    return (
        <Fragment>
            <ErrorUi
                img={image_error_account}
                title="Echec lors de la validation"
                msg="Votre compte n'a pas pu être créé"
            />
        </Fragment>
    );
}
